import React from 'react';
import View from '../modalView';

const EditProjectModal = ({ ...props }) => (
  <View
    modalTitle="Edit project"
    action="Save"
    name="editProjectModal"
    {...props}
  />
);
export default EditProjectModal;
